import { render, staticRenderFns } from "./ReviewYourAnswersTRIS.vue?vue&type=template&id=12273e10"
import script from "./ReviewYourAnswersTRIS.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersTRIS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports